// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"0bb5ca64","412":"b59661cc","418":"d1cc2189","479":"3306f18f","493":"40ba1f8e","540":"bc33be71","561":"3fae23ac","626":"2e982200","631":"28b6ede4","637":"421e1b76","680":"24e3f652","716":"ad7b4a50","878":"cc8ebd17"}[chunkId] + ".chunk.js";
};